var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 948,
    viewBox: "0 0 1440 948",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1704_34411)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1704_34411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 948
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 0H0V948H1440V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1704_34411)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0H0V948H1440V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1704_34411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423 839L1046.5 1192.5L1475.5 1320.5L1449 309L1352.5 1063L1046.5 159L1245.5 1101L843 465L1016.5 978L532 593L1027.5 1117L423 839Z",
    fill: "#844EDB",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1704_34411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1263.06 493.686L1072.14 -197.157L859.305 -591.016L162.805 142.961L764.2 -321.962L341.35 533.638L866.73 -273.171L701.621 461.159L941.683 -24.2693L1012.04 590.56L1032.19 -130.336L1263.06 493.686Z",
    fill: "#4E75DB"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1704_34411",
    x: 123,
    y: -141,
    width: 1652.5,
    height: 1761.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_1704_34411"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1704_34411",
    x: -137.195,
    y: -891.016,
    width: 1700.26,
    height: 1781.58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_1704_34411"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1704_34411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 948,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.6a2d6a390a433c329bfd6f71df008673.svg";
export { ForwardRef as ReactComponent };